var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -125 -384 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145 384  C 156.2 384  165 392.8  165 404  C 165 415.2  156.2 424  145 424  C 133.8 424  125 415.2  125 404  C 125 392.8  133.8 384  145 384  Z ",
    fillRule: "nonzero",
    fill: "#c5e3fc",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingBackground);
export default __webpack_public_path__ + "static/media/waiting_background.0fdbac100631afb2246915d6114b705e.svg";
export { ForwardRef as ReactComponent };